import { dateFnsFormat } from '@/helpers/dateFns';
import BaseModel from '@/models/list/base';
import { localeFormatDefault } from '@/plugins/date-print';

export default class LevelDocument extends BaseModel {
  #currentDate;

  constructor(document, url) {
    super(document, url);

    this.title = document.title || '';
    this.description = document.description || '';
    this.show_after_at = localeFormatDefault(document.show_after_at);
    this.show_before_at = localeFormatDefault(document.show_before_at);
    this.level = document.level;
    this.root_event_id = document.root_event_id;
    this.initiate_event_id = document.initiate_event_id;
    this.nomination_ids = document.nomination_ids || [];
    this.group_ids = document.group_ids || [];
    this.nominations = document.nominations || [];
    this.groups = document.groups || [];
    this.organizer_id = document.organizer_id || [];
    this.documents = document.documents || []; // expand

    this.#currentDate = new Date();
  }

  get isShowingNotStart() {
    const start = new Date(this.show_after_at);
    return this.#currentDate < start;
  }

  get isShowingEnd() {
    const end = new Date(this.show_before_at);
    return this.#currentDate > end;
  }

  get isShowingPeriod() {
    return !this.isShowingNotStart && !this.isShowingEnd;
  }

  get statusData() {
    const { show_after_at, show_before_at } = this;
    const { readableMonthGenitiveName, getDay } = dateFnsFormat;
    if (this.isShowingPeriod) {
      return {
        text: `Доступно до ${Number(getDay(show_before_at))} ${readableMonthGenitiveName(show_before_at).toLowerCase()}`,
        color: 'ui-success',
      };
    }
    if (this.isShowingNotStart) {
      return {
        text: `Станет доступно ${Number(getDay(show_after_at))} ${readableMonthGenitiveName(show_after_at).toLowerCase()}`,
        color: 'ui-warning',
      };
    }
    return {
      text: `Недоступно с ${Number(getDay(show_before_at))} ${readableMonthGenitiveName(show_before_at).toLowerCase()}`,
      color: 'ui-error',
    };
  }
}
